<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar Ação
        </b-button>
        <acao-plano-trabalho-form
            operacaoProp="I"
            :convenio="convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></acao-plano-trabalho-form>
    </div>
</template>

<script>
import AcaoPlanoTrabalhoForm from './AcaoPlanoTrabalhoForm'

export default {
    components: {
        AcaoPlanoTrabalhoForm
    },

    props: {
        convenio: Object,
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            acao: {
                idConvenio:0,
                nomeAcao: null,
                codGestor: null,
                vcCodUnidade:null,
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(acao){
            this.$store.dispatch('addRequest')
            let acaoDto = {
                idConvenio : acao.idConvenio,
                nomeAcao: acao.nomeAcao,
                codGestor: acao.codGestor,
                vcCodUnidade: acao.VcCodUnidade,
            }
            this.dataServicos.inserirAcaoPlanoTrabalho(acaoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Ação inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
